import {type FormEventHandler, useState, useRef, useEffect} from 'react';
import {useIntl} from 'react-intl';
import {Input} from '@time-webkit/all/atoms';
import {CheckIcon} from '@time-webkit/all/icons';

import {ActionButton} from '../../action-button';

import styles from './inline-link-form.module.css';

type InlineLinkFormProps = {
    value?: string;
    onSubmit?: (value: string, withHotkey: boolean) => void;
    autoselection?: boolean;
};

export const InlineLinkForm = ({onSubmit, value = '', autoselection}: InlineLinkFormProps) => {
    const ref = useRef<HTMLInputElement>(null);
    const submitByHotkey = useRef(true);
    const {formatMessage} = useIntl();
    const [linkValue, setLinkValue] = useState(value);
    const label = formatMessage({id: 'editor.link-popover.link-field.label', defaultMessage: 'Input link'});
    const handleFormSubmit: FormEventHandler = (event) => {
        event.stopPropagation();
        event.preventDefault();
        onSubmit?.(linkValue, submitByHotkey.current);
    };

    useEffect(() => {
        if (autoselection) {
            ref.current?.focus();
            ref.current?.select();
        }
    }, [autoselection]);

    return (
        <form className={styles.inlineLinkForm} onSubmit={handleFormSubmit}>
            <Input
                ref={ref}
                className={styles.linkInput}
                value={linkValue}
                onChange={setLinkValue}
                aria-label={label}
                placeholder={label}
            />

            <div className={styles.buttonsWrapper}>
                <ActionButton
                    data-testid='inlineLinkFormSubmit'
                    icon={<CheckIcon className={styles.checkIcon}/>}
                    type='submit'
                    onClick={() => {
                        submitByHotkey.current = false;
                    }}
                />
            </div>
        </form>
    );
};
